<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.928 2.914C14.373 1.01 16.383 1 16.383 1s.299 1.791-1.137 3.517c-1.533 1.842-3.276 1.54-3.276 1.54s-.327-1.448.958-3.143Zm-.774 4.398c.743 0 2.123-1.022 3.92-1.022 3.092 0 4.309 2.2 4.309 2.2s-2.38 1.217-2.38 4.169c0 3.33 2.964 4.477 2.964 4.477s-2.072 5.832-4.87 5.832c-1.285 0-2.285-.866-3.639-.866-1.38 0-2.75.898-3.642.898-2.555 0-5.784-5.532-5.784-9.979 0-4.374 2.733-6.67 5.296-6.67 1.666 0 2.96.961 3.826.961Z"
      fill="currentColor"
    />
  </svg>
</template>
